import { createContext } from 'react';

export interface ActiveContextContextType {
  activeContextId: string | null;
  setActiveContextId: (contextId: string | null) => void;
}

export const ActiveContextContext = createContext<ActiveContextContextType | undefined>(undefined);
